import { Component, Input } from '@angular/core';
import { PrimaryButtonComponent } from "../../../../../shared/components/primary-button/primary-button.component";
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { Router } from '@angular/router';
import { LocationFileUploadComponent } from "../../../../file-upload/components/location-file-upload/location-file-upload.component";
import { ToastComponent } from '../../../../../shared/components/toast/toast.component';

@Component({
  selector: 'app-add-new-location-step-one-dialog',
  standalone: true,
  imports: [PrimaryButtonComponent, CommonModule, TranslocoPipe, LocationFileUploadComponent],
  templateUrl: './add-new-location-step-one-dialog.component.html',
  styleUrl: './add-new-location-step-one-dialog.component.css'
})
export class AddNewLocationStepOneDialogComponent {
  modalDialogId: string = 'locations_modal_add_upload'

  // Callback function for opening add new location input dialog
  @Input() callbackFunction!: () => void;
  @Input() toast!: ToastComponent;


  uploading: boolean = false;

  fileName: string = "A2A627672.pdf";
  precentage: number = 60;

  constructor(private router: Router) { }

  openModal(): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.showModal();
    }
  }

  closeModal(): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.close();
    }
  }

  // Calling function from parent on click
  addDataClick() {
    this.closeModal();
    if (this.callbackFunction) {
      this.callbackFunction();
    }
  }

  navigateToFileUpload() {
    this.router.navigate(['/file-upload']);
  }
}
